import { batch, signal } from "@preact/signals-react"

// Table data
export const tableData = signal([])
export const totalCount = signal(0)

// Loading states
export const isLoadingTable = signal(false)

// Filters
export const selectedBrand = signal(null)

// Mappings modal
export const mappingsModal = signal(null)

// Edit mapping drawer
export const editMappingDrawer = signal(null)

export const clearSkuManagementSignals = () => batch(() => {
    tableData.value = []
    totalCount.value = 0
    isLoadingTable.value = false
    selectedBrand.value = null
    mappingsModal.value = null
    editMappingDrawer.value = null
})
